export const DIVIDER_ROLE = 'separator' as const;
